import React from 'react';
import { SvgIcon, Typography } from '@material-ui/core';
import { useStyle } from './job-summary-item.style';

type JobSummaryItemProps = {
    icon: React.ReactNode;
    title: string;
    text: string;
};

export const JobSummaryItem: React.FC<JobSummaryItemProps> = ({ icon, title, text }) => {
    const classes = useStyle();

    return (
        <li className={classes.content}>
            <SvgIcon className={classes.icon} color="primary">
                {icon}
            </SvgIcon>
            <div>
                <Typography className={classes.title}>{title}</Typography>
                <Typography className={classes.text}>{text}</Typography>
            </div>
        </li>
    );
};
